export const CALCULATION_TYPES = {
  FAIXA_PESO: 1,
  FAIXA_KM: 2,
  FAIXA_VOLUME: 3,
  TONELADA: 4,
  VIAGEM: 5,
  COMISSAO: 6,
  PERCENTUAL_NF: 7,
};

export const CALCULATION_TYPE_LABELS = {
  1: 'Faixa de peso',
  2: 'Faixa de km',
  3: 'Faixa de volume',
  4: 'Tonelada',
  5: 'Viagem',
  6: 'Comissão',
  7: 'Percentual sobre NF',
};

export function resolveCalculationTypeLabel(code) {
  return CALCULATION_TYPE_LABELS[code] || null;
}
